export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex flex-col lg:flex-row px-8 md:px-16 lg:px-24 pt-16 md:pt-24 pb-0">
        <div className="lg:w-[60%] flex flex-col justify-start">
          <h1 className="text-[clamp(40px,6vw,96px)] font-bold text-foreground-950 leading-[1.05] font-heading tracking-tight">
            LLN GROUP, UAB
          </h1>
          <div className="mt-10 md:mt-16 lg:mt-20 max-w-[90%]">
            <p className="text-[clamp(28px,4vw,58px)] font-light text-foreground-900 leading-[1.2] font-heading">
              Engineering the future
            </p>
            <p className="text-[clamp(28px,4vw,58px)] font-light text-foreground-900 leading-[1.2] font-heading">
              of digital software
            </p>
            <p className="text-[clamp(28px,4vw,58px)] font-light text-foreground-900 leading-[1.2] font-heading">
              for modern platforms
            </p>
          </div>
        </div>
        <div className="lg:w-[40%] flex flex-col justify-end lg:justify-start lg:pt-24 mt-10 lg:mt-0">
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-md">
            A professional engineering team focused on designing and developing scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
          </p>
          <div className="mt-8 w-32 h-32 rounded-3xl border border-foreground-300"></div>
        </div>
      </div>
      <div className="mt-12 md:mt-20 w-full">
        <div className="w-full h-[280px] md:h-[420px] rounded-t-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20texture%20with%20soft%20grain%20effect%2C%20flowing%20gradient%20from%20warm%20cream%20to%20light%20beige%2C%20neutral%20tones%2C%20contemporary%20digital%20art%2C%20non%20figurative%2C%20smooth%20blend%2C%20large%20format%20artistic%20composition%2C%20subtle%20texture%20overlay&width=1600&height=600&seq=lln-hero-band&orientation=landscape"
            alt="Abstract geometric texture with soft grain"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}